import { render, staticRenderFns } from "./help-message-center.vue?vue&type=template&id=d246af32&scoped=true&lang=pug"
import script from "./help-message-center.vue?vue&type=script&lang=ts"
export * from "./help-message-center.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d246af32",
  null
  
)

export default component.exports